/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon64Regular = forwardRef('MoneyCurrencyRubleIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.5 39H23v6h13.5a1.5 1.5 0 0 1 0 3H23v7.5a1.5 1.5 0 0 1-3 0V48h-5.5a1.5 1.5 0 0 1 0-3H20v-6h-5.5a1.5 1.5 0 0 1 0-3H20V12.136A4.136 4.136 0 0 1 24.136 8H36.5C45.06 8 52 14.94 52 23.5 52 32.06 45.06 39 36.5 39ZM23 12.136c0-.627.509-1.136 1.136-1.136H36.5C43.404 11 49 16.596 49 23.5S43.404 36 36.5 36H23V12.136Z" })));
});
